<template>
  <div>
    <SGPTabelaComponent
      v-if="listagemPerfis.length"
      titulo="Adicionar menu aos perfis"
      :colunas="colunas"
      :dados="listagemPerfis"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :somenteLeitura="true"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingPerfil" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import deletar from "@/././common/mixins/deletar.js";

export default {
  name: 'ListagemPerfilMenuPage',
  mixins: [deletar],
  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      usuariosSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      usuario: {}
    }
  },

  created () {
    this.listarPerfis()
  },

  computed: {
    ...mapGetters('perfis', ['listaDePerfis','loadingPerfil']),

    listagemPerfis () {
      return this.listaDePerfis.map(perfil => {
        perfil.redirecionar = `perfis-menus/${perfil.id}`
        return perfil
      })
    },

    colunas () {
      return [ 
        {
          key: 'name',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'redirecionar',
          label: 'Menus',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('perfis', [
      'listarPerfis',
      'deletarUsuario'
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.usuariosSelecionados = selecionados
    },

    adicionarNovoUsuario () {
      this.abrirModal = true
      this.tipoFormulario = 'salvar'
      this.usuario = {}
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.usuario = this.usuariosSelecionados[0]
      this.abrirModal = true
    },

    confirmarDelecao () {
      this.deletarDados = false      
      console.log('Confirmou a deleção')

      this.usuariosSelecionados.forEach(async usuario => {
        await this.deletarUsuario(usuario); 
      })
    },

    fecharModal () {
      this.abrirModal = false
    }

  }
}
</script>
